import { selfApi } from '@/shared/services/api'

export const getAuthConfig = () => {
  const enabledProviders = ['google', 'facebook']

  return {
    httpClient: selfApi,
    afterSignInRedirectUrl: '/jornadas',
    disableReCaptcha: true,
    customNavigation: false,
    enabledProviders,
    authRoutes: {
      signIn: '/sign-in',
      signUp: '/sign-up',
      forgotPassword: '/forgot-password',
      resetPassword: '/reset-password',
      confirmation: '/confirmation',
      resendConfirmation: '/resend-confirmation'
    },
    signIn: {
      loginLabel: 'E-mail',
      hideForgotPasswordAction: false
    },
    signUp: {
      withEmailConfirmation: true,
      skipConfirmation: true
    },
    forgotPassword: {},
    resetPassword: {},
    resendConfirmation: {}
  }
}
